var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.401,
    height: 30.34,
    viewBox: "0 0 30.401 30.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.456,2a7.2,7.2,0,0,0-.182,14.4,1.224,1.224,0,0,1,.334,0h.106A7.2,7.2,0,0,0,11.456,2Z",
    transform: "translate(-0.776 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.346,14.871a15.062,15.062,0,0,0-15.4,0,5.988,5.988,0,0,0-2.988,4.9A5.937,5.937,0,0,0,4.933,24.64a14.016,14.016,0,0,0,7.706,2.139,14.016,14.016,0,0,0,7.706-2.139,5.985,5.985,0,0,0,2.973-4.9A5.973,5.973,0,0,0,20.346,14.871Z",
    transform: "translate(-1.96 3.561)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.03,9.038a5.429,5.429,0,0,1-4.748,5.871h-.076a.71.71,0,0,0-.258.03,5.443,5.443,0,0,1-3.838-1.259,6.942,6.942,0,0,0,2.275-5.764,7.04,7.04,0,0,0-1.168-3.307,5.447,5.447,0,0,1,7.812,4.43Z",
    transform: "translate(4.321 -0.938)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.126,18.7a4.62,4.62,0,0,1-2.64,3.61A10.707,10.707,0,0,1,18.162,23.5a5.415,5.415,0,0,0,1.851-3.519,5.977,5.977,0,0,0-2.533-5.127A12.523,12.523,0,0,0,13.99,12.94a11.856,11.856,0,0,1,10.164,1.775A4.609,4.609,0,0,1,26.126,18.7Z",
    transform: "translate(4.259 3.428)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.d9e871c7.svg";
export { ForwardRef as ReactComponent };